import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationComponent } from '@shared/components/notification/notification.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(
    private modalService: BsModalService,
    private translateService: TranslateService,
    private toastr: ToastrService,
  ) {}

  showLoader() {
    const loader = document.getElementById('main-loader');
    if (loader) {
      loader.style.display = 'flex';
    }
  }

  hideLoader() {
    const loader = document.getElementById('main-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }

  async showConfirm(message: string, title: string, size = 'modal-custom') {
    const modal = this.openModal('confirm', message, size, title);
    const confirm = await this.closeModal(modal);
    if (confirm === true) {
      return true;
    }

    return false;
  }

  showSuccess(message = 'success') {
    const modal = this.openModal('success', message);
    return this.closeModal(modal);
  }

  showError(message = 'error') {
    const modal = this.openModal('error', message);
    return this.closeModal(modal);
  }

  showToastySuccess(message = 'success') {
    this.toastr.success(message);
  }

  showToastyError(message = 'error') {
    this.toastr.error(message);
  }

  private openModal(
    type: string,
    message: string,
    size = 'sm',
    title?: string,
  ) {
    const initialState: ModalOptions = {
      initialState: {
        type,
        message,
        title,
      },
      class: `modal-${size} modal-dialog-centered`,
    };

    return this.modalService.show(NotificationComponent, initialState);
  }

  private closeModal(modal: BsModalRef<NotificationComponent>) {
    return new Promise((resolve, reject) => {
      modal.onHide?.subscribe(
        (value: unknown) => {
          if (value instanceof NotificationComponent) {
            resolve(null);
          } else {
            resolve(value);
          }
        },
        (error: any) => {
          reject(error);
        },
      );
    });
  }

  encryptPassword(password: string): string {
    const value = password + '_' + new Date().getTime();
    const SECRET_KEY = CryptoJS.enc.Hex.parse(environment.CRYPTO_SECRET_KEY);
    const IV = CryptoJS.enc.Hex.parse(environment.CRYPTO_IV);
    const encrypted = CryptoJS.AES.encrypt(value, SECRET_KEY, {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString(); // base64 string
  }

  trans(key: string, params?: any) {
    return this.translateService.instant(key, params);
  }

  /**
   * Clear all open modals and hide loader
   */
  clearAllModals(): void {
    this.modalService.hide();
    this.hideLoader();
  }
}
